import { useParams } from "react-router";

//Hooks
import useVoucher from "../../../hooks/vouchers/useVoucher";

//Components
import InvoiceDetail from "../../../components/invoice/detail/index";
import Title from "../../../components/invoice/detail/title";
// import Title from "./title";

const Voucher = () => {
  const { voucherId } = useParams();
  const { voucher, loading } = useVoucher(voucherId)

  const title = (
    <Title 
      voucherReference={voucher.voucherReference}
      voucherReferencePath={`/cashRegisters/invoices/${voucher.voucherReference}`}
      vouchersPath="/cashRegisters/vouchers"
      voucherLabel="Factura"
      title="Informacion sobre la Nota de crédito"
    /> 
  )
  
  return(
      <InvoiceDetail
          invoice={voucher}
          loading={loading}
          title={title}
          voucherLabel="Nota de Crédito"
      />
  )
}

export default Voucher;